var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-ons-navigator',{class:{ 'border-radius': _vm.borderRadius },attrs:{"swipeable":"","swipe-target-width":"50px","page-stack":_vm.pageStack,"pop-page":_vm.storePop,"options":{
    animation: 'fade',
    animationOptions: {duration: 0.2, timing: 'ease-in'}
  }}})
}
var staticRenderFns = []

export { render, staticRenderFns }